import React, { CSSProperties, PropsWithChildren } from 'react'
import styled from 'styled-components'
import { SVG_ICON_SIZE_CSS_VAR, SVG_ICON_SIZES, SvgIconSize, determineSvgIconSize } from '../SvgIcon'

const StyledIconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  height: var(${SVG_ICON_SIZE_CSS_VAR}, ${SVG_ICON_SIZES.M});
  width: var(${SVG_ICON_SIZE_CSS_VAR}, ${SVG_ICON_SIZES.M});

  &.variant-bubble {
    border-radius: 50%;
    background-color: ${props => props.theme.palette.brand.primary.normal};
    color: ${props => props.theme.palette.neutral.default.eight};
  }
`

interface Props {
  /**
   * Icon size symbol to pixel maps:
   *
   * - `XS` = 16px
   * - `S` = 20px
   * - `M` = 24px
   * - `L` = 32px
   * - `XL` = 40px
   *
   * @default M (24px)
   */
  size?: SvgIconSize | number
  className?: string
}

/**
 * A wrapper component that maintains consistent dimensions for icons.
 * Useful when swapping between different icons (e.g., icon and loading spinner)
 * to prevent layout shift.
 */
function IconWrapper(props: PropsWithChildren<Props>) {
  const { size, children, className } = props

  const mappedSize = determineSvgIconSize(size)

  return (
    <StyledIconWrapper
      className={className}
      style={{
        [SVG_ICON_SIZE_CSS_VAR]: mappedSize,
      } as CSSProperties}
    >
      {children}
    </StyledIconWrapper>
  )
}

export default IconWrapper
